import { ComboBox, PanelType, PrimaryButton, TextField } from '@fluentui/react';
import React from 'react';
import { isNullOrEmpty } from '../../utilities';
import { Column } from '../Column';
import { Grid } from '../Grid';
import { Row } from '../Row';
import { StandarPanel } from '../StandarPanel';
export class ReactRenderer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            jsCode: props.jsCode,
            error: false,
            errorMessages: '',
            errorInfo: null,
            compiledComponent: null
        };
    }
    componentDidMount() {
        this.compileFunction();
    }
    compileFunction() {
        var _a, _b;
        try {
            const jsCode = this.state.jsCode;
            if (isNullOrEmpty(jsCode))
                return null;
            const $$ = (type, props, ...children) => {
                const element = React.createElement(type, props, ...children);
                return element;
            };
            const code = `
                ${jsCode}
                return $$(Main, null);
            `;
            const unathorized_variables = [
                'window', 'document', 'navigator', 'location', 'history', 'localStorage', 'sessionStorage', 'cookie', 'XMLHttpRequest', 'fetch',
                'FileReader', 'WebSocket', 'IndexedDB', 'performance', 'screen', 'addEventListener', 'alert', 'removeEventListener',
                'setTimeout', 'clearTimeout', 'setInterval', 'clearInterval', 'requestAnimationFrame', 'cancelAnimationFrame', 'requestIdleCallback',
                'cancelIdleCallback', 'Promise', 'CustomEvent', 'Event', 'FormData', 'URL', 'URLSearchParams', 'Headers', 'AbortController', 'AbortSignal',
                'Window', 'Document', 'Navigator'
            ];
            const componentNames = [
                ...unathorized_variables,
                'React',
                'Grid',
                'Row',
                'Column',
                'TextField',
                'PrimaryButton',
                'ComboBox',
                'StandarPanel',
                'PanelType',
                '$$',
                ...((_a = this.props.types) === null || _a === void 0 ? void 0 : _a.map(x => x.name)) || []
            ];
            const components = [
                ...unathorized_variables.map(x => null),
                React,
                Grid,
                Row,
                Column,
                TextField,
                PrimaryButton,
                ComboBox,
                StandarPanel,
                PanelType,
                $$,
                ...((_b = this.props.types) === null || _b === void 0 ? void 0 : _b.map(x => x.component)) || []
            ];
            try {
                const fn = new Function(...componentNames, code).bind({}, ...components);
                const compiledComponent = fn();
                this.setState({ compiledComponent: compiledComponent });
            }
            catch (error) {
                console.log('error');
            }
        }
        catch (error) {
            this.setState({
                error: true,
                errorMessages: error.message,
                errorInfo: error
            });
        }
    }
    render() {
        var _a, _b;
        if (this.state.error)
            return React.createElement("div", { style: { color: 'red' } },
                React.createElement("div", { style: { fontWeight: 'bold' } },
                    React.createElement("p", null, "Error rendering component")),
                React.createElement("div", null, this.state.errorMessages),
                React.createElement("div", null, (_b = (_a = this.state.errorInfo) === null || _a === void 0 ? void 0 : _a.componentStack) === null || _b === void 0 ? void 0 : _b.split('\n').map(x => React.createElement("div", null, x))));
        if (this.state.compiledComponent == null)
            return React.createElement(React.Fragment, null);
        return React.createElement(React.Fragment, null, this.state.compiledComponent);
    }
    componentDidCatch(error, errorInfo) {
        this.setState({
            error: true,
            errorMessages: error.message,
            errorInfo: errorInfo
        });
    }
}
